module.exports = __webpack_public_path__ + "media/images/flags/IL-07bfcd43b5f8d0aec9b8428830bd7e91.svg";